import { useCallback } from 'react';
import { SERVER_ROUTES } from 'b2b-apps/shop/routes/components/Router/routes';
import { simulateLinkClick } from 'b2b-apps/shop/routes/utils/url';

export type UseLogoutActionType = () => void;

export const useLogoutAction = (): UseLogoutActionType => useCallback(
  () => {
    simulateLinkClick(SERVER_ROUTES.logout);
  },
  [],
);
